/**
 * useMembershipCertificatePort — port-factory hook returning a stable
 * MembershipCertificatePort adapter.
 *
 * The composer (main.tsx) and the test harness call this once to obtain a
 * MembershipCertificatePort instance for PortsProvider. useState's lazy
 * initialiser keeps the adapter reference stable across re-renders.
 *
 * As of 049, constructs the REAL tRPC-backed adapter
 * (`RealMembershipCertificateAdapter` over `member.certificate`) — the
 * certificate is now generated server-side from data Oma+ already holds (no
 * separate integration, D-215/FR-003), returned as a genuine PDF. The demo
 * `.txt` adapter is RETIRED (FR-007) — see 026's superseded RD-006 framing,
 * reconciled by D-215.
 *
 * Owned by feature 026-proto-convergence-v2; reshaped by
 * 049-membership-certificate.
 */

import { useState } from 'react';
import type { MembershipCertificatePort } from '../membership-certificate/MembershipCertificatePort.js';
import { RealMembershipCertificateAdapter } from '../membership-certificate/RealMembershipCertificateAdapter.js';
import { createWebTrpcClient } from '../trpc/client.js';

export function useMembershipCertificatePort(): MembershipCertificatePort {
  const [port] = useState<MembershipCertificatePort>(
    () => new RealMembershipCertificateAdapter(createWebTrpcClient()),
  );

  return port;
}
